/**
 * A row of mutually exclusive alternatives, drawn as one segmented control.
 *
 * The radio itself is visually hidden rather than replaced: it is what the
 * arrow keys drive, what reports the checked state, and what the label's `for`
 * relationship makes clickable. The segment is the label's ground.
 *
 * Shared rather than private to the appearance menu because the Mini App's
 * mode dial is the same control in a second place — the profile's settings —
 * and a copy of it there would be a second drawing of one choice.
 */
export function Segmented<TValue extends string | number>({
  name,
  options,
  value,
  onPick,
}: {
  name: string
  options: Array<{ id: TValue; label: string }>
  value: TValue
  onPick: (next: TValue) => void
}) {
  return (
    <div className="appearance-choice">
      {options.map((option) => (
        <label key={String(option.id)} className="appearance-choice__option">
          <input
            className="visually-hidden appearance-choice__input"
            type="radio"
            name={name}
            checked={value === option.id}
            onChange={() => onPick(option.id)}
          />
          <span className="appearance-choice__label">{option.label}</span>
        </label>
      ))}
    </div>
  )
}
